export const normalizeSsnInput = (str: string) => {
  return str.replace(/-/g, '');
};

export const normalizeNationalIdOnChange = (str: string) => {
  return str.replace(/[^a-zA-Z0-9\s/.-]/g, ' ').trimStart();
};

// TODO: once all apps use the same zod version, export a shared nameSchema(messages) builder here
export const NAME_REGEX = /^[a-zA-ZÀ-ÿ\-_' ]*$/;
export const MIN_NAME_CHARS = 2;
export const MAX_NAME_CHARS = 30;
